import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import CategoriesForm from './CategoriesForm'
import privateView from '../../components/hocs/privateView';
import Analytics from "../../services/Analytics";

class CategoriesDetail extends Component{
	componentDidMount(){
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('category_detail', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }
  render(){
    return(
      <Container>
        <CategoriesForm 
          edit
          title="Categories Detail" 
          {...this.props}
        />
      </Container>
    )
  }
}

const mapStateToProps = ({auth: { isFetch, roles, isLogged, id, email } })=>({
  guardData: { isFetch, roles, isLogged, id, email }
})
  
const enhance = connect(mapStateToProps);
export default enhance(privateView(CategoriesDetail));